var jQuery = require('jquery');
var Vue = require('vue');
require('jquery.easing');
const Masonry = require('masonry-layout');

window.jQuery = jQuery;
window.$ = jQuery;

// var Popper = require('popper.js');
// window.Popper = Popper;
require('moment');

// require('bootstrap');
require('bootstrap/js/dist/alert');
require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');

// var Cookies = require('jquery.cookie');
require('jquery.cookie');

const feather = window.feather = require('feather-icons')

require('owl.carousel');
require('jquery-countdown');
require('magnific-popup');

// require('lazysizes');
// require('picturefill');
var jsonp = require('jsonp');
var Mmenu = require('mmenu-js').default;

window.jsonp = jsonp;

window.initProductCarousel = () => {

}


$(function() {


    var urlParams = new URLSearchParams(window.location.search);

    // check embed mode
    if (urlParams.has('embed')) {
        // replace all links
        Array.from(document.links).forEach(el => {

            // except hash change
            var href = String(el.href);
            if (href.indexOf(window.location.href) >= 0 && href.match(/#/)) {
                return;
            }

            el.href = 'javascript:void(0)';
        });
    }

    $('#form-customer-register [data-toggle="tooltip"]').tooltip({
        template: '<div class="tooltip register-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });

    $('input[data-toggle=label]').on('input', function(e) {
        $(`label:has(input[name=${e.target.name}])`).removeClass('active');

        if (e.target.checked) {
            $(e.target).closest('label').addClass('active');
        }
    })

    /* $('.btn-collapse').click(function () {
        $(this).find('.feather').toggleClass('d-none');
    }); */



    let hasMenu = window.document.getElementById('mob-menu');
    if (!!hasMenu) {
        // Mmenu.configs.offCanvas.page.nodetype = "section";

        const mmenu = new Mmenu("#mob-menu", {
        "extensions": [
             "position-front",
        ]
        }, {
            // configuration
            offCanvas: {
                page: {
                    selector: "#offcanvas"
                }
            }
        });
        const mmenuApi = mmenu.API;
    }

    $('.cart-sidebar').on('click', () => {
        $('.sidebar-bg').addClass('d-block');
        $('body').addClass('cart-flyopen');
        $('.sidebar-cart').addClass('open').css('right', 0);
        window.dispatchEvent(new CustomEvent('cart-sidebar_open'));
    });

    $('.sidebar-bg').on('click', () => {
        window.dispatchEvent(new CustomEvent('cart-sidebar_close'));
    });

    $(".btn-menu").on('click', function () {
        $(".btn-menu").toggle();
        $("#header-search").removeClass('down');
        $('.btn-search').removeClass('active');
    });

    $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        gallery: {
            enabled: false
        },
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                },
                gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                }

                // you may add here more sources

            },

            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });

    //feather icons
    feather.replace()




    $('#best-buy-countdown').countdown('2020/02/25').on('update.countdown', function(event) {
        var $this = $(this).html(event.strftime('' +
            '<span class="unit"><span>%-D</span> day%!D</span>' +
            '<span class="unit"><span>%H</span> hr </span>' +
            '<span class="unit d-none d-md-inline-flex"><span>%M</span> min</span>' +
            '<span class="unit d-none d-md-inline-flex"><span>%S</span> sec</span>'));
    });

    $('.selectpicker').selectpicker();


    function initCarouselVideo(item) {
        if ($(item).find('.video-container').length) {
            var video = $(item).find('video')[0];
            video.play();

            $carousel.trigger('stop.owl.autoplay');

            $(video).off('ended').on('ended', function(event) {
                $carousel.trigger('next.owl.carousel');
            });
        } else {
            $carousel.trigger('play.owl.autoplay');
        }
    }

    if ($('#main-carousel').length) {
        $carousel = $('#main-carousel');
        $carousel.owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            responsiveClass: true,
            margin: 0,
            dots: false,
            nav: false,
            autoplay: true,
            center: false,
            autoplayTimeout: 10000,
            smartSpeed: 750,
            items: 1,
            onInitialized: function(e) {
                var position = e.item.index;
                var item = $carousel.find('.item')[position]
                initCarouselVideo(item);
            }
        });

        $carousel.on('changed.owl.carousel', function(event) {
            var position = event.property.value;
            var item = $carousel.find('.item')[position]
            initCarouselVideo(item);
        })
    }

    if ($('#category-carousel').length) {
        $('#category-carousel').owlCarousel({
            // responsiveRefreshRate: 1,
            loop: true,
            responsiveClass: true,
            margin: 0,
            dots: false,
            nav: false,
            autoplay: true,
            center: true,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            items: 1,
        });
    }

    if ($('.announcement-carousel').length) {
        $('.announcement-carousel').owlCarousel({
            // responsiveRefreshRate: 1,
            loop: true,
            // responsiveClass: true,
            margin: 0,
            dots: false,
            nav: false,
            autoplay: true,
            center: true,
            autoplayTimeout: 4000,
            smartSpeed: 750,
            items: 1,
        });
    }


    if ($('#recommended-carousel').length) {
        $('#recommended-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            responsiveClass: true,
            margin: 20,
            dots: true,
            autoplay: false,
            center: false,
            autoplayTimeout: 4000,
            smartSpeed: 750,
            responsive: {

                0: {
                    items: 1
                },

                576: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4,
                    dots: false,
                    nav: true
                },
                1790: {
                    items: 5,
                    dots: false,
                    nav: true
                }

            }
        });
    }

    if ($('#related-carousel').length) {
        $('#related-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            responsiveClass: true,
            margin: 20,
            dots: true,
            autoplay: true,
            center: false,
            autoplayTimeout: 4000,
            smartSpeed: 750,
            responsive: {

                0: {
                    items: 1
                },

                576: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4,
                    dots: false,
                    nav: true
                },
                1790: {
                    items: 5,
                    dots: false,
                    nav: true
                }

            }
        });
    }


    if ($('.cta-carousel').length) {
        $('.cta-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            responsiveClass: true,
            dots: true,
            autoplay: false,
            center: false,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            responsive: {

                0: {
                    items: 1
                },

                650: {
                    items: 2,
                    margin: 30
                },
                768: {
                    items: 2,
                    margin: 30
                },
                992: {
                    items: 2,
                    autoplay: false,
                    margin: 100
                },
                1200: {
                    items: 3,
                    autoplay: false,
                    margin: 50
                }
            }
        });
    }

    // page scroll
    if ($('.page-scroll').length) {
        $('.page-scroll').bind('click', function(event) {
            var $anchor = $(this);

            var $headerHeight = $(".navbar--main").outerHeight();

            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top
            }, 750, 'easeInOutExpo');

            event.preventDefault();
        });
    };

    $(window).on('scroll load', function() {

        var headerHeight = $(".header-offset").outerHeight() + 16;
        var navOffset = $(".header-offset").offset().top - $(window).scrollTop() + headerHeight;

        if (navOffset <= 0) {
            $(".vue-notification-group").css("top", 16);
        } else {
            $(".vue-notification-group").css("top", navOffset );
        }

    });

    if ($('#product-thumb-carousel').length) {
        initProductCarousel();
    };
    //end product carousel

    if ($("#btn-grid").data('clicked')) {
        $("#list-filter").hide();
    }

    $('.btn-collapse').on('click', function () {
        $(this).find('.circle-plus').toggleClass('opened');
    })

    $('.btn-announcement').on('click', function () {
        $(".announcement-wrapper").animate({
            height: 0,
            opacity: 0
        }, 150, function() {
            $(this).hide();
        });
        $.cookie('announcement', 'active', {
            expires: 1, //days
            path: '/'
        });
    })

    if ($.cookie('announcement') != "active") {
        if ($(".announcement-wrapper").length) {
            $(".announcement-wrapper").show();
        }
    } else {
        if ($(".announcement-wrapper").length) {
            $(".announcement-wrapper").hide();
        }
    }

    $(window).on('load', function() {
        $(window).trigger('resize');
    });


  /*   $('.header-login').on('click',function() {
        $(".header-search-backdrop").removeClass('show');
        $(".header-search").hide();
    }) */

  /*   $('[id$="-button"]').on("click", function(e) {
        var color = $(this).attr('data-color');
        var colorBackdrop = 'modal-backdrop-' + color;
        // alert(color);
        $('#modal-backdrop').addClass(colorBackdrop);
    }); */

    $('.btn-close, .modal').on("click", function(e) {
        var color = $('.show').attr('data-color');
        var activeBackdrop = 'modal-backdrop-' + color;
        $('#modal-backdrop').removeClass(activeBackdrop);
    });

    $('.btn-search').on('click',function(e) {
        // mmenuApi.close();
        $(".btn-menu.header-link[href='#offcanvas']").hide();
        $(".btn-menu.header-link[href='#mob-menu']").show();
        $(".header-search").toggleClass('down');
        $(".header-search-backdrop").toggleClass('show');
        $(this).toggleClass('active');
        e.preventDefault();
    })

    $('.header-search-backdrop').on('click',function() {
        $(".header-search").slideToggle();
        $(this).toggleClass('show');
    })

    $('#modal-backdrop').on('click',function() {
        $(this).addClass('hide');
    })


    // add custom hover toggle for nav links
    // $('[data-toggle-hover]').hover(function() {
    //     var $this = $(this);
    //     var targetClass = $this.data('toggle-hover');
    //     var $target = $this.closest('.' + targetClass).find('.' + targetClass + '-menu');
    //     $target.addClass('show');
    //     $target.parent().off('mouseleave').on('mouseleave', function() {
    //         $target.removeClass('show');
    //     })
    // })

    // Search Filters Datepicker
    // Using font-awesome 5 icons
    $.extend(true, $.fn.datetimepicker.defaults, {
        icons: {
            time: 'fa fa-clock',
            date: 'fa fa-calendar',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-calendar-check-o',
            clear: 'fa fa-calendar-times-o',
            close: 'fa fa-times-circle'

        }
    });
    $('.datepicker-start').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true
    });
    $('.datepicker-end').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        useCurrent: false //Important! See issue #1075
    });

    $('.datepicker-start').on("dp.change", function(e) {
        $('.datepicker-end').data('DateTimePicker').minDate(e.date);
    });

    $('.datepicker-end').on("dp.change", function(e) {
        $('.datepicker-start').data('DateTimePicker').maxDate(e.date);
    });

    $('.reset-filter').on('click', function(e) {
        e.preventDefault();
        $(this).closest('form').find('input[type=text]').val('');
    });

    window.addEventListener('vue-init', () => {
        setTimeout(() => {
            stickyFooter()
        }, 0);
    });

    setTimeout(() => {
        scrollToFormError();
    }, 0);


    $("#gallery li img").hover(function () {
        $('#main-img').attr('src', $(this).attr('src').replace('thumb/', ''));
    });
    var imgSwap = [];
    $("#gallery li img").each(function () {
        imgUrl = this.src.replace('thumb/', '');
        imgSwap.push(imgUrl);
    });
    $(imgSwap).preload();
});
$.fn.preload = function () {
    this.each(function () {
        $('<img/>')[0].src = this;
    });
}



// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset

    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());


            if (windowWidth > 992) {
                var offsetSize = $('#header').height() + 80;
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            } else {
                var offsetSize = $('#header').height() + 140;
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            }
        }
    }
}

// Initialize Masonry layouts
function initializeMasonry() {
    document.querySelectorAll('[data-masonry]').forEach(function(element) {
        const options = JSON.parse(element.getAttribute('data-masonry') || '{}');
        new Masonry(element, options);
    });
}

// Initialize masonry on page load
initializeMasonry();

// Initialize masonry when dropdown menus are shown
$('.dropdown-toggle').on('click', function() {
    // Wait a moment for the dropdown to fully open
    setTimeout(function() {
        initializeMasonry();
    }, 10);
});



// https://help.sharpspring.com/hc/en-us/articles/115002321292-Submitting-Directly-to-Native-Form-Endpoints
window.postToSharpSpring = function postToSharpSpring(params){

    var __ss_noform = window.__ss_noform || [];

    var url = 'https://app-3QNP1F5B2A.marketingautomation.services/webforms/receivePostback/MzawMLEwMzG0BAA/';
    var endpoint = '21001cc3-24ec-4c6f-8249-7e3e92d08c8c';
    var endpointurl = url + endpoint + '/jsonp/';

    let ssTracking = $.cookie('__ss_tk');
    params += '&trackingid__sb='+ssTracking;

    window.jsonp(endpointurl+'?'+params, null, (err, data) => {
        console.log(err, data)
    });

    return true;

}

window.trackingEvent = function trackingEvent(eventName, data) {
    let event = new CustomEvent(eventName, {
        detail: data,
    });
    window.dispatchEvent(event);
}

window.goBack = () => {
    window.history.go(-1);
}

window.stickyFooter = () => {
    // var wrapperHeight = $(document.body).height();

    // var win = $(window).height();
    // var win = 600;

    // if (wrapperHeight < win) {
    //     $(".footer-nav").addClass('fixed-bottom');
    // } else {
    //     $(".footer-nav").removeClass('fixed-bottom');
    // }

    // if ($('#sticky-footer').length) {
    //     $(".footer-nav").addClass("footer-cart-margin");
    // } else {
    //     $(".footer-nav").removeClass("footer-cart-margin");
    // }
}

/*
window.fixFooter = () => {
    var wrapperHeight = $(document.body).height();

    var win = $(window).height();

    if (wrapperHeight < win) {
        $("#footer").addClass('fixed-bottom');
    } else {
        $("#footer").removeClass('fixed-bottom');
    }
} */

window.dispatchEvent(new CustomEvent('init'));
window.dispatchEvent(new CustomEvent('js-init'));